import { createSlice } from "@reduxjs/toolkit";

const accountDetailsSlice = createSlice({
  name: "accountDetails",
  initialState: {
    loading: false,
    error: null,
    jobs: [],
    // counts: { positive: 0, open: 0, closed: 0 }
    counts: {},
    allLeadsCount: {},
    allLeadsCountLoading: false,
    companies: [],
    pendingCompanies: [],
    // to store client submissions data
    clientSubmissions: {
      data: [],

    },
    myLeadsPendingCompanies: [],


  },
  reducers: {
    getAccountDetailsStart(state, action) {
      state.loading = true;
      state.error = null;
    },
    getAccountDetailsSuccess(state, action) {
      state.loading = false;
      state.jobs = action.payload.data;
    },
    getAccountDetailsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearAccountDetails(state) {
      state.jobs = [];
      state.error = null;
      state.loading = false;
    },
    updateCompanyInList: (state, action) => {
      const updated = action.payload;
      const companyList = state.companies?.[0]?.data || [];
      const idx = companyList.findIndex(c => c.uiid === updated.uiid);
      if (idx !== -1) {
        companyList[idx] = { ...companyList[idx], ...updated };
      }
    },
    updateAccountStatus(state, action) {
      const { uiid, status } = action.payload;
      const index = state.jobs.findIndex((job) => job.uiid === uiid);
      if (index !== -1) {
        state.jobs[index].status = status;
      }
    },
    // for fetching prospect by email
    getProspectByEmailStart: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    getProspectByEmailSuccess: (state, action) => {
      state.loading = false;
    },
    getProspectByEmailFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // for counts
    getJobCountStart(state, action) {
      state.loading = true;
      state.error = null;
    },
    getJobCountSuccess(state, action) {
      state.loading = false;
      state.counts = action.payload;
    },
    getJobCountFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    // getting all companies 
    getCompaniesStart(state) {
      state.loading = true;
      state.error = null;
    },
    getCompaniesSuccess(state, action) {
      state.loading = false;
      state.companies = action.payload.data;
    },
    getCompaniesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    getAllLeadsCountStart(state) {
      state.loading = true;
      state.allLeadsCountLoading = true;
      state.error = null;
    },
    getAllLeadsCountSuccess(state, action) {
      state.loading = false;
      // console.log("getAllLeadsCountSuccess",action.payload)
      state.allLeadsCountLoading = false;
      state.allLeadsCount = action.payload;
    },
    getAllLeadsCountFailure(state, action) {
      state.loading = false;
      state.allLeadsCountLoading = false;
      state.error = action.payload;
    },
    //to`get client submissions data


    getClientSubmissionsStart(state) {
      state.loading = true;
      state.error = null;
    },
    getClientSubmissionsSuccess(state, action) {
      state.loading = false;
      state.clientSubmissions.data = action.payload.data;
    },
    getClientSubmissionsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearClientSubmissions(state) {
      state.clientSubmissions.data = [];
    },
    getPendingCompaniesStart(state) {
      state.loading = true
      state.error = null;
    },
    getPendingCompaniesSuccess(state, action) {
      state.loading = false
      state.pendingCompanies = action.payload;
    },
    getPendingCompaniesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    getMyLeadsPendingCompaniesStart(state) {
      state.loading = true
      state.error = null;
    },
    getMyLeadsPendingCompaniesSuccess(state, action) {
      state.loading = false
      state.myLeadsPendingCompanies = action.payload;
    },
    getMyLeadsPendingCompaniesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    }
  },
});

export const {
  getAccountDetailsStart,
  getAccountDetailsSuccess,
  getAccountDetailsFailure,
  clearAccountDetails,
  getProspectByEmailStart,
  getProspectByEmailSuccess,
  getProspectByEmailFailure,
  getJobCountStart,
  getJobCountSuccess,
  getJobCountFailure,
  getCompaniesStart,
  getCompaniesSuccess,
  getCompaniesFailure,
  getClientSubmissionsStart,
  getClientSubmissionsSuccess,
  getClientSubmissionsFailure,
  clearClientSubmissions,
  updateCompanyInList,
  getAllLeadsCountStart,
  getAllLeadsCountSuccess,
  getAllLeadsCountFailure,
  updateAccountStatus,
  getPendingCompaniesStart,
  getPendingCompaniesSuccess,
  getPendingCompaniesFailure,
  getMyLeadsPendingCompaniesStart,
  getMyLeadsPendingCompaniesSuccess,
  getMyLeadsPendingCompaniesFailure
} = accountDetailsSlice.actions;

export default accountDetailsSlice.reducer;
